var _path, _g, _path2, _path3, _path4, _g2, _g3, _rect, _rect2, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJackpotDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 568,
    height: 327,
    viewBox: "0 0 568 327",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_32050_273",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 161,
    y: 0,
    width: 250,
    height: 73
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M161 8C161 3.58172 164.582 0 169 0H286H403C407.418 0 411 3.58172 411 8V73H161V8Z",
    fill: "#014A73"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_32050_273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161 16C161 7.16346 168.163 0 177 0H286H395C403.837 0 411 7.16344 411 16V37.35V56C411 64.8366 403.837 72 395 72H177C168.163 72 161 64.8366 161 56V37.35V16Z",
    fill: "url(#paint0_radial_32050_273)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.231 -24.9785C428.092 -32.0822 424.485 -38.9203 420.344 -45.4264L289.956 36.7634L381.334 -87.1188C375.122 -91.6997 368.509 -95.8158 361.562 -99.4672L289.889 36.7634L306.722 -116.065C302.848 -116.463 298.973 -116.795 295.099 -116.928C291.225 -117.06 287.284 -116.994 283.41 -116.861L289.889 36.7634L227.567 -103.982C220.42 -100.861 213.54 -97.1436 207.061 -92.9611L289.889 36.7634L165.379 -53.9906C160.837 -47.75 156.762 -41.1775 153.155 -34.273L289.889 36.8298L136.857 20.0998C136.523 23.6184 136.189 27.2034 136.055 30.7885C135.922 34.971 136.055 39.0871 136.189 43.1368L289.889 36.7634L149.281 98.3063C152.421 105.344 156.161 112.115 160.303 118.555L289.889 36.8298L199.312 159.65C205.524 164.164 212.07 168.214 218.95 171.733L289.956 36.8298L273.323 188.065C277.131 188.463 280.938 188.795 284.812 188.928C288.687 189.06 292.561 188.994 296.368 188.861L289.956 36.8963L351.676 176.247C358.757 173.127 365.57 169.542 372.116 165.492L290.022 36.8963L413.797 127.053C418.406 120.879 422.548 114.439 426.155 107.601L290.089 36.8298L442.988 53.4936C443.455 49.4438 443.789 45.3277 443.923 41.1452C444.056 37.5601 443.99 33.9751 443.923 30.3901L290.089 36.7634L431.298 -24.9785H431.231Z",
    fill: "#D8F1FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_32050_273)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 286,
    cy: 51.5,
    rx: 82,
    ry: 18.5,
    fill: "url(#paint1_linear_32050_273)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M205.367 48V26.1H209.867V43.95H218.717V48H205.367ZM227.705 48.3C225.485 48.3 223.725 47.7 222.425 46.5C221.145 45.3 220.505 43.66 220.505 41.58V26.1H225.005V41.55C225.005 42.47 225.235 43.18 225.695 43.68C226.175 44.16 226.845 44.4 227.705 44.4C228.545 44.4 229.205 44.16 229.685 43.68C230.165 43.18 230.405 42.47 230.405 41.55V26.1H234.905V41.58C234.905 43.64 234.255 45.28 232.955 46.5C231.675 47.7 229.925 48.3 227.705 48.3ZM244.734 48.3C243.274 48.3 241.994 48.03 240.894 47.49C239.794 46.93 238.934 46.16 238.314 45.18C237.714 44.18 237.414 43.02 237.414 41.7V32.4C237.414 31.06 237.714 29.9 238.314 28.92C238.934 27.94 239.794 27.18 240.894 26.64C241.994 26.08 243.274 25.8 244.734 25.8C246.214 25.8 247.494 26.08 248.574 26.64C249.674 27.18 250.524 27.94 251.124 28.92C251.744 29.9 252.054 31.06 252.054 32.4H247.554C247.554 31.52 247.304 30.85 246.804 30.39C246.324 29.93 245.634 29.7 244.734 29.7C243.834 29.7 243.134 29.93 242.634 30.39C242.154 30.85 241.914 31.52 241.914 32.4V41.7C241.914 42.56 242.154 43.23 242.634 43.71C243.134 44.17 243.834 44.4 244.734 44.4C245.634 44.4 246.324 44.17 246.804 43.71C247.304 43.23 247.554 42.56 247.554 41.7H252.054C252.054 43.02 251.744 44.18 251.124 45.18C250.524 46.16 249.674 46.93 248.574 47.49C247.494 48.03 246.214 48.3 244.734 48.3ZM254.232 48V26.1H258.732V34.68H260.832L264.492 26.1H269.352L264.792 36.45L269.532 48H264.612L260.862 38.61H258.732V48H254.232ZM275.82 48V40.2L269.52 26.1H274.23L276.99 32.7C277.27 33.36 277.51 34.06 277.71 34.8C277.93 35.54 278.08 36.14 278.16 36.6C278.26 36.14 278.4 35.54 278.58 34.8C278.78 34.06 279.01 33.36 279.27 32.7L281.94 26.1H286.62L280.32 40.2V48H275.82ZM304.537 48V26.1H311.647C313.167 26.1 314.487 26.39 315.607 26.97C316.747 27.55 317.627 28.37 318.247 29.43C318.887 30.47 319.207 31.7 319.207 33.12V40.95C319.207 42.35 318.887 43.58 318.247 44.64C317.627 45.7 316.747 46.53 315.607 47.13C314.487 47.71 313.167 48 311.647 48H304.537ZM309.037 43.95H311.647C312.547 43.95 313.277 43.67 313.837 43.11C314.417 42.55 314.707 41.83 314.707 40.95V33.12C314.707 32.24 314.417 31.53 313.837 30.99C313.277 30.43 312.547 30.15 311.647 30.15H309.037V43.95ZM321.415 48V26.1H328.435C329.995 26.1 331.345 26.37 332.485 26.91C333.625 27.45 334.505 28.22 335.125 29.22C335.765 30.22 336.085 31.4 336.085 32.76C336.085 34.18 335.735 35.45 335.035 36.57C334.355 37.69 333.425 38.5 332.245 39L336.385 48H331.495L327.955 39.72H325.855V48H321.415ZM325.855 35.82H328.435C329.435 35.82 330.205 35.57 330.745 35.07C331.305 34.57 331.585 33.87 331.585 32.97C331.585 32.03 331.305 31.3 330.745 30.78C330.205 30.26 329.435 30 328.435 30H325.855V35.82ZM336.973 48L342.343 26.1H348.043L353.473 48H348.883L347.833 43.05H342.613L341.563 48H336.973ZM343.363 39.45H347.053L346.003 34.17C345.863 33.41 345.713 32.66 345.553 31.92C345.413 31.16 345.303 30.57 345.223 30.15C345.143 30.57 345.033 31.15 344.893 31.89C344.773 32.63 344.633 33.38 344.473 34.14L343.363 39.45ZM355.352 48L353.312 26.1H356.882L357.992 40.74C358.012 41.02 358.032 41.42 358.052 41.94C358.092 42.44 358.122 42.97 358.142 43.53C358.182 44.07 358.202 44.56 358.202 45C358.242 44.56 358.282 44.07 358.322 43.53C358.382 42.97 358.432 42.44 358.472 41.94C358.532 41.42 358.572 41.02 358.592 40.74L360.332 26.1H363.752L365.432 40.74C365.472 41.02 365.512 41.42 365.552 41.94C365.612 42.44 365.672 42.97 365.732 43.53C365.792 44.07 365.842 44.56 365.882 45C365.902 44.56 365.922 44.07 365.942 43.53C365.962 42.97 365.982 42.44 366.002 41.94C366.042 41.42 366.072 41.02 366.092 40.74L367.112 26.1H370.712L368.522 48H363.842L362.372 33.45C362.352 33.11 362.312 32.67 362.252 32.13C362.212 31.57 362.172 30.99 362.132 30.39C362.092 29.79 362.052 29.26 362.012 28.8C361.992 29.26 361.962 29.79 361.922 30.39C361.882 30.99 361.842 31.57 361.802 32.13C361.762 32.67 361.722 33.11 361.682 33.45L360.062 48H355.352Z",
    fill: "#003044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164 16C164 8.82031 169.82 3 177 3H286H395C402.18 3 408 8.8203 408 16V37.35V56C408 63.1797 402.18 69 395 69H177C169.82 69 164 63.1797 164 56V37.35V16Z",
    stroke: "#115A83",
    strokeWidth: 6
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 101C20 96.5817 23.5817 93 28 93H540C544.418 93 548 96.5817 548 101V235H20V101Z",
    fill: "#115A83"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 257H568V319C568 323.418 564.418 327 560 327H8.00001C3.58173 327 0 323.418 0 319V257Z",
    fill: "url(#paint2_linear_32050_273)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 257H568L548 235H20L0 257Z",
    fill: "#0D527A"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_32050_273)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 119,
    r: 8,
    fill: "#fea900"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    dur: "1s",
    values: "#fea900;#0D527A;#fea900",
    repeatCount: "indefinite",
    begin: 0.1
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 149,
    r: 8,
    fill: "#fea900"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    dur: "1s",
    values: "#fea900;#0D527A;#fea900",
    repeatCount: "indefinite",
    begin: 0.2
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 179,
    r: 8,
    fill: "#fea900"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    dur: "1s",
    values: "#fea900;#0D527A;#fea900",
    repeatCount: "indefinite",
    begin: 0.3
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 209,
    r: 8,
    fill: "#fea900"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    dur: "1s",
    values: "#fea900;#0D527A;#fea900",
    repeatCount: "indefinite",
    begin: 0.4
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_32050_273)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 518,
    cy: 119,
    r: 8,
    fill: "#fea900"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    dur: "1s",
    values: "#fea900;#0D527A;#fea900",
    repeatCount: "indefinite",
    begin: 0.4
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 518,
    cy: 149,
    r: 8,
    fill: "#fea900"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    dur: "1s",
    values: "#fea900;#0D527A;#fea900",
    repeatCount: "indefinite",
    begin: 0.3
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 518,
    cy: 179,
    r: 8,
    fill: "#fea900"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    dur: "1s",
    values: "#fea900;#0D527A;#fea900",
    repeatCount: "indefinite",
    begin: 0.2
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 518,
    cy: 209,
    r: 8,
    fill: "#fea900"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    dur: "1s",
    values: "#fea900;#0D527A;#fea900",
    repeatCount: "indefinite",
    begin: 0.1
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 221,
    width: 410,
    height: 5,
    fill: "#0D527A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 102,
    width: 410,
    height: 5,
    fill: "#0D527A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M161.5 240.5H66.5L54.5 251.5H150.5L161.5 240.5Z",
    fill: "#09486C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M271.5 240.5H176.5L171.5 251.5H269.5L271.5 240.5Z",
    fill: "#09486C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M298.5 240.5H393.5L398.5 251.5H300.5L298.5 240.5Z",
    fill: "#09486C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M211 70.5V98",
    stroke: "#115A83",
    strokeWidth: 8
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M361 70.5V98",
    stroke: "#115A83",
    strokeWidth: 8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_32050_273",
    x: 180,
    y: 9,
    width: 212,
    height: 85,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "effect1_foregroundBlur_32050_273"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_32050_273",
    x: 26,
    y: 95,
    width: 48,
    height: 138,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.254902 0 0 0 0 0.721569 0 0 0 0 0.921569 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_32050_273"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_32050_273",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_32050_273",
    x: 494,
    y: 95,
    width: 48,
    height: 138,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.254902 0 0 0 0 0.721569 0 0 0 0 0.921569 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_32050_273"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_32050_273",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_32050_273",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(286 36) rotate(90) scale(36 125)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0092D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0177A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_32050_273",
    x1: 286,
    y1: 33,
    x2: 286,
    y2: 70,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EA7E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01BBBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_32050_273",
    x1: 0.00000172879,
    y1: 301,
    x2: 568,
    y2: 302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#086BA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005F95"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJackpotDark);
export default __webpack_public_path__ + "static/media/jackpot_dark.91a5a3fdef2dacac6e01a87ff498b135.svg";
export { ForwardRef as ReactComponent };